import { render, staticRenderFns } from "./validateProducts.vue?vue&type=template&id=28ab4e11&scoped=true"
import script from "./validateProducts.vue?vue&type=script&lang=js"
export * from "./validateProducts.vue?vue&type=script&lang=js"
import style0 from "./validateProducts.vue?vue&type=style&index=0&id=28ab4e11&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28ab4e11",
  null
  
)

export default component.exports